import { useTranslation } from "react-i18next";

import CloseNavigationIcon from "@mui/icons-material/KeyboardDoubleArrowLeftRounded";
import OpenNavigationIcon from "@mui/icons-material/KeyboardDoubleArrowRightRounded";
import { IconButton, Tooltip } from "@mui/material";

interface Props {
  isNavigationCollapsed: boolean;
  onToggleNavigationCollapse: (collapsed: boolean) => void;
}

export function ExpandCollapseButton({ isNavigationCollapsed, onToggleNavigationCollapse }: Props) {
  const { t } = useTranslation();
  const label = isNavigationCollapsed ? t("layout.navigation.openNavigation") : t("layout.navigation.closeNavigation");

  return (
    <Tooltip title={label} placement="right" arrow>
      <IconButton
        aria-label={label}
        aria-expanded={!isNavigationCollapsed}
        onClick={() => onToggleNavigationCollapse(!isNavigationCollapsed)}
        size="small"
        sx={{
          px: isNavigationCollapsed ? 0 : undefined,
          borderRadius: 0.5,
          color: "action.active",
          "&:hover": { color: "text.primary" },
        }}
      >
        {isNavigationCollapsed ? <OpenNavigationIcon /> : <CloseNavigationIcon />}
      </IconButton>
    </Tooltip>
  );
}
